import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// NewUser layout schemas for form and form feilds
import validations from "./schemas/Validations";
import form from "./schemas/Form";

import { io } from "socket.io-client";

import { URL_API } from "config";
import { useAuthContext } from "context/AuthContext";
import CooperatedDataFirst from "./components/steps/CooperatedDataFirst";
import CooperatedDocumentsSecond from "./components/steps/CooperatedDocumentsSecond";
import CooperatedInfoThird from "./components/steps/CooperatedInfoThird";
import CooperatedContactsFourth from "./components/steps/CooperatedContactsFourth";
import CooperatedAddressFifth from "./components/steps/CooperatedAddressFifth";
import CooperatedComplementsSixth from "./components/steps/CooperatedComplementsSixth";
import CooperatedDescriptionsSeventh from "./components/steps/CooperatedDescriptionsSeventh";
import CooperatedMessagesEighth from "./components/steps/CooperatedMessagesEighth";
import initialValues from "./schemas/InitialValues";

const socket = io(URL_API);

export default function UpdateCooperated() {
  const { uuid } = useParams();

  const [cooperated, setCooperated] = useState({});

  const [activeStep, setActiveStep] = useState(0);

  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const steps = user?.profile === 99 ? ["Colaborador", "Documentos", "Dados", "Contatos", "Endereço", "Renda", "Descrição", "Mensagens"] : ["Mensagens", "Colaborador", "Documentos", "Dados", "Contatos", "Endereço", "Renda", "Descrição"];
  const query = useQuery();
  const step = Number(query.get("step") ?? '0');
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const { formId } = form;

  const getStepsData = () => {
    if (user?.profile === 99) {
      switch (step) {
        case 0:
          return <CooperatedDataFirst />;
        case 1:
          return <CooperatedDocumentsSecond />;
        case 2:
          return <CooperatedInfoThird />;
        case 3:
          return <CooperatedContactsFourth />;
        case 4:
          return <CooperatedAddressFifth />;
        case 5:
          return <CooperatedComplementsSixth />;
        case 6:
          return <CooperatedDescriptionsSeventh />;
        case 7:
          return <CooperatedMessagesEighth />;
        default:
          return <CooperatedDataFirst />;
      }
    } else {
      switch (step) {
        case 0:
          return <CooperatedMessagesEighth />;
        case 1:
          return <CooperatedDataFirst />;
        case 2:
          return <CooperatedDocumentsSecond />;
        case 3:
          return <CooperatedInfoThird />;
        case 4:
          return <CooperatedContactsFourth />;
        case 5:
          return <CooperatedAddressFifth />;
        case 6:
          return <CooperatedComplementsSixth />;
        case 7:
          return <CooperatedDescriptionsSeventh />;
        default:
          return <CooperatedMessagesEighth />;
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setActiveStep(step);

        const response = await axios.get(URL_API + `/cooperated/${uuid}`, {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        });

        if (response.data.status === 9) {
          const index = steps.indexOf("Mensagens");

          if (index > -1) steps.splice(index, 1)
        };

        setCooperated(response.data);
      } catch (error) {
        console.error(error);
      }
    })()
    // eslint-disable-next-line
  }, [])

  useEffect(() => setActiveStep(step), [step]);

  const handleSubmit = async (_, actions) => {
    if (isLastStep) {
      if (user.company_id) {
        const companyName = await axios.get(URL_API + `/company/${user.company_id}`, {
          headers: {
            Authorization: `Bearer ${tag}`,
            "Content-Type": "multipart/form-data",
          },
        });

        const message = `${companyName.data.name} atualizou ${cooperated.gender === 2 ? 'a colaboradora' : 'o colaborador'} ${cooperated.full_name}.`

        socket.emit("updated", { message: message, date_time: new Date(), company_id: null });
      } else {
        const message = `Viacredi atualizou ${cooperated.gender === 2 ? 'a colaboradora' : 'o colaborador'} ${cooperated.full_name} do CPF ${cooperated.cpf}`

        socket.emit("updated", { message: message, date_time: new Date(), company_id: cooperated.company_id });
      }
    } else {
      setActiveStep(step + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={5}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100%", mt: 8 }}
          >
            <Grid item xs={12} lg={8}>
              <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
                onSubmit={handleSubmit}
              >
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={2} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox p={3}>
                      <MDBox>
                        {getStepsData()}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
}
